import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ContactForm, Contact } from "../models";

@Injectable()
export class ContactService {

    contactsUrl = environment.dns + 'api/contacts/';

    constructor(private http: HttpClient) { }

    getListByCustomer(customerId: number): Observable<Contact[]> {
        return this.http.get<Contact[]>(this.contactsUrl +'list-by-customer?customerId='+ customerId);
    }

    getOne(id: number): Observable<Contact> {
        return this.http.get<Contact>(this.contactsUrl + id);
    }

    add(contactForm: ContactForm): Observable<Contact> {
        return this.http.post<Contact>(this.contactsUrl, contactForm);
    }

    update(contactForm: ContactForm): Observable<Contact> {
        return this.http.put<Contact>(this.contactsUrl, contactForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.contactsUrl + id);
    }
}